export const CONFIG_PATH = `${process.env.PUBLIC_URL || ''}/config.json`;
